module.exports = __webpack_public_path__ + "img/7_george_d.95f8b641.png";